import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, TextField } from '@/DesignSystem/Component';
import { messageCreateAction } from '@/Module/Contact/Store/Action/messageCreateAction';
import { FORM_GLOBAL_VALIDATION_ERROR } from '@/Module/Core/Constant';
import { yup } from '@/Module/Core/Helper';
import { IconMobile, IconUserSquare } from '@/Module/Icon';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
interface IForm {
  fullName: string;
  mobileNumber: string;
}
const HomeNewCounselingForm: FC = () => {
  const dispatch = useAppDispatch();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const isLoading = useAppSelector(state => state.contactUs.isLoading);
  const schema = useMemo(() => {
    return yup.object({
      fullName: yup.string().required(),
      mobileNumber: yup.string().required().min(11, 'شماره تماس صحیح نیست.').max(11, 'شماره تماس صحیح نیست.')
    });
  }, []);
  const {
    control,
    handleSubmit,
    reset
  } = useForm<IForm>({
    resolver: yupResolver(schema)
  });
  const onSubmit = handleSubmit(data => {
    dispatch(messageCreateAction({
      fullName: data.fullName,
      messageTypeId: 2,
      mobileNumber: data.mobileNumber
    })).unwrap().then(() => {
      enqueueSnackbar({
        variant: 'success',
        message: 'شماره شما با موفقیت ثبت شد.'
      });
      reset();
    });
  }, () => {
    enqueueSnackbar({
      variant: 'error',
      message: FORM_GLOBAL_VALIDATION_ERROR
    });
  });
  return <Box color="secondaryLight" className=" mt-10 !border-blueFour !bg-white p-6 sm:p-10" data-sentry-element="Box" data-sentry-component="HomeNewCounselingForm" data-sentry-source-file="HomeNewCounselingForm.tsx">
      <form onSubmit={onSubmit} noValidate className="flex flex-col flex-wrap ">
        <div className="flex w-full flex-col sm:flex-row">
          <div className="relative ml-2 w-full sm:pb-8">
            <TextField control={control} disabled={isLoading} name="mobileNumber" label="شماره موبایلت رو بنویس" prefix={<IconMobile />} autoComplete="off" className=" mb-2  w-full " errorClassName="sm:absolute sm:bottom-1" data-sentry-element="TextField" data-sentry-source-file="HomeNewCounselingForm.tsx" />
          </div>
          <div className="relative w-full sm:pb-8">
            <TextField control={control} disabled={isLoading} name="fullName" type="text" label="اسمت رو بنویس" prefix={<IconUserSquare />} autoComplete="off" className=" mb-2 mt-1 w-full  sm:m-0" errorClassName="sm:absolute sm:bottom-1" data-sentry-element="TextField" data-sentry-source-file="HomeNewCounselingForm.tsx" />
          </div>
        </div>
        <Button isLoading={isLoading} variant="shadow" color="primary" radius="circle" type="submit" className="mt-2 w-fit self-end" data-sentry-element="Button" data-sentry-source-file="HomeNewCounselingForm.tsx">
          ثبت نام در خبرنامه
        </Button>
      </form>
    </Box>;
};
export default HomeNewCounselingForm;